import { TooltipAlignType } from '@kubit-ui-web/react-components';
import { RELOADED_VARIANTS } from '@kubit/web-ui-product-components';
const INPUT_TOOLTIP_ICON_PROPS = {
    icon: 'icon_symbols_information-in-a-circle',
    height: '24px',
    width: '24px',
}, INPUT_TOOLTIP_PROPS = {
    align: TooltipAlignType.TOP,
    variant: RELOADED_VARIANTS.TooltipVariantType.REGULAR,
    tooltipAsModal: false,
};
export { INPUT_TOOLTIP_ICON_PROPS, INPUT_TOOLTIP_PROPS };
//# sourceMappingURL=input-tooltip.constants.js.map